const bigrams = [
  'ST',
  'EN',
  'AT',
  'NA',
  'TE',
  'OV',
  'PO',
  'RO',
  'IT',
  'BÝ',
  'NÍ',
  'ÝT',
  'SE',
  'VA',
  'LE',
  'KO',
  'NÝ',
  'TA',
  'PR',
  'OD',
  'NO',
  'RA',
  'DO',
  'KA',
  'AK',
  'CH',
  'ON',
  'PŘ',
  'OS',
  'TO',
  'OU',
  'JE',
  'CE',
  'ED',
  'ŘE',
  'LA',
  'ÍT',
  'LO',
  'ER',
  'AN',
  'NĚ',
  'KÝ',
  'NI',
  'ZA',
  'ET',
  'IN',
  'LI',
  'OB',
  'NE',
  'HO',
  'VÝ',
  'EL',
  'OL',
  'AD',
  'AL',
  'SK',
  'ŽE',
  'DN',
  'AV',
  'DE',
  'TI',
  'DA',
  'OR',
  'IC',
  'OT',
  'MO',
  'OK',
  'UT',
  'TR',
  'VĚ',
  'ES',
  'EK',
  'VY',
  'PA',
  'VO',
  'RÁ',
  'ŘÍ',
  'ŘI',
  'EC',
  'VE',
  'KT',
  'AS',
  'ÁT',
  'MÍ',
  'OM',
  'NÁ',
  'MA',
  'OC',
  'RÝ',
  'AR',
  'DI',
  'VI',
  'OZ',
  'ZE',
  'ĚT',
  'SL',
  'JA',
  'IS',
  'NT',
  'CI',
  'CH',
];

const a1 = new Set([
  'B',
  'C',
  'Č',
  'D',
  'Ď',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'M',
  'N',
  'Ň',
  'P',
  'Q',
  'R',
  'Ř',
  'S',
  'Š',
  'T',
  'Ť',
  'V',
  'W',
  'X',
  'Z',
  'Ž',
]);
const a2 = new Set(['A', 'Á', 'E', 'É', 'Ě', 'I', 'Í', 'O', 'Ó', 'U', 'Ů', 'Ú', 'Y', 'Ý']);
const a3 = new Set(['M', 'R', 'L', 'S']);

const bigramSet = new Set(bigrams);

function score(array: string[], original: string): number {
  let score = 0;

  if (array[0] === original[0]) score -= 50;

  for (let i = 0; i < array.length - 1; i++) {
    const bigram = array[i] + array[i + 1];
    if (bigramSet.has(bigram)) score += 30;
    if (a1.has(array[i]) && a2.has(array[i + 1])) score += 10;
    if (a1.has(array[i]) && a3.has(array[i + 1])) score += 5;
  }

  return score;
}

export interface IRandom {
  next(min: number, max: number): number;
}

export function anagram(word: string, random: IRandom): string {
  const upper = word.toUpperCase().replace(/[^\p{L}\p{N}]/gu, '');

  if (word.length <= 2) {
    return upper;
  }

  let count = 10;
  let iterations = 10;

  if (word.length <= 4) {
    count = 5;
    iterations = 3;
  }

  const w1: string[][] = [];
  for (let i = 0; i < count; i++) {
    const arr = upper.split('');
    for (let j = arr.length - 1; j > 0; j--) {
      const k = random.next(0, j + 1);
      [arr[j], arr[k]] = [arr[k], arr[j]];
    }
    w1.push(arr);
  }

  let counter = 0;
  while (true) {
    counter++;
    let topIdx = 0;
    let topScore = score(w1[0], upper);
    for (let i = 1; i < w1.length; i++) {
      const s = score(w1[i], upper);
      if (s > topScore) {
        topScore = s;
        topIdx = i;
      }
    }
    const top = w1[topIdx];
    const topStr = top.join('');

    if (counter >= iterations && topStr !== upper) {
      return topStr;
    }

    const list: string[][] = [];
    for (let i = 0; i < w1.length; i++) {
      const copy = [...top];

      const number = 1 + random.next(0, 3);

      for (let j = 0; j < number; j++) {
        const n1 = random.next(0, word.length);
        const n2 = random.next(0, word.length);

        if (n1 !== n2) {
          [copy[n1], copy[n2]] = [copy[n2], copy[n1]];
        }
      }

      if (copy.join('') !== upper) {
        list.push(copy);
      }
    }

    if (list.length === 0) {
      return topStr;
    }

    w1.length = 0;
    for (const item of list) {
      w1.push(item);
    }
  }
}
